module.exports = __webpack_public_path__ + "media/img/icons/search-no-results-761067f4292444c23c72d963d8fbb522.svg";